module.exports = __webpack_public_path__ + "static/img/special_sauce_6_pack.81de1d7.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/special_sauce_6_pack.jpg
// module id = 306
// module chunks = 1